module.exports = __webpack_public_path__ + "img/ic_alif.02c04014.png";